<div
    style="display: flex;justify-content: space-between;height: 7%;align-items: center; color:#545454eb;padding: 0 0.5rem;">
    <div></div>
    <span multilang>
        <button mat-dialog-close mat-icon-button>
            <mat-icon>close</mat-icon>
        </button>
    </span>
</div>
<div style="display: flex;flex-direction: column;overflow:auto;height: 91% !important;padding: 0 0.5rem;">
    <div *ngIf="datas">
        <div style="display: flex;flex-direction: column;padding: .5rem;overflow: hiden;margin-top: .5rem;">
            <div
                style="display: flex;flex-direction: column;justify-content: space-between;flex-wrap: wrap;align-items: center;color:#545454eb;">
                <!--CarParkName-->
                <span multilang style="text-align: center;font-weight: 800;font-size: 1.3rem;">
                    {{datas.CarParkName}}
                </span>
                <div style="display: flex;flex-direction: row;justify-content: center;flex-wrap: wrap;">
                    @for (img of data.infos.imageList; track $index) {
                    @if(img.url?.length > 0) {
                    <img [src]="img.url" loading="lazy" style="width:calc(50% - 2rem);margin: 0.5rem;">
                    }
                    }
                </div>
                <span multilang class="cc1">Wichtige Informationen</span>
                <!--Address-->
                <div class="infoline">
                    <span multilang class="cc2">Adresse</span>
                    <span multilang style="width: 60%;">
                        {{datas.Address}}
                    </span>
                </div>
                <!--Transfer-->
                <div class="infoline">
                    <span multilang class="cc2">Transferinformationen</span>
                    <span multilang style="width: 60%;">
                        {{datas.Transfer}}
                    </span>
                </div>
                <!--ShuttleTimes-->
                <div class="infoline">
                    <span multilang class="cc2">Zeiten</span>
                    <span multilang style="width: 60%;">
                        {{datas.ShuttleTimes}}
                    </span>
                </div>
                <!--ShuttleFrequency-->
                @if(datas.ShuttleFrequency) {
                <div class="infoline">
                    <span multilang class="cc2">Häufigkeit</span>
                    <span multilang style="width: 60%;">
                        {{datas.ShuttleFrequency}}
                    </span>
                </div>
                }
                <!--Special-->
                @if(datas.Special) {
                <div class="infoline">
                    <span multilang class="cc2">Individueller Transfer</span>
                    <span multilang style="width: 60%;">
                        {{datas.Special}}
                    </span>
                </div>
                }
                <!--ArrivalProcedure-->
                <div class="infoline">
                    <span multilang class="cc2">Bei der Anreise</span>
                    <span multilang style="width: 60%;">
                        {{datas.ArrivalProcedure}}
                    </span>
                </div>
                <!--DepartureProcedure-->
                <div class="infoline">
                    <span multilang class="cc2">Bei der Abreise</span>
                    <span multilang style="width: 60%;">
                        {{datas.DepartureProcedure}}
                    </span>
                </div>
                <!--Weitere informationen-->
                <span multilang class="cc1">Weitere informationen</span>
                <!--CarSizeInfo-->
                <div class="infoline">
                    <span multilang class="cc2">Fahrzeuggröße</span>
                    <span multilang style="width: 60%;">
                        {{datas.CarSizeInfo}}
                    </span>
                </div>
                <!--Accessibility-->
                <div class="infoline">
                    <span multilang class="cc2">Informationen für Behinderte</span>
                    <span multilang style="width: 60%;">
                        {{datas.Accessibility}}
                    </span>
                </div>
                <!--Accessibility-->
                <!--span>Zusatzinformationen</span>
                <span  multilang   style="font-weight: 500;">
                    {{datas.Accessibility}}
                </span-->
                <!--SecurityInfo-->
                <div class="infoline">
                    <span multilang class="cc2">Sicherheitsinformationen</span>
                    <span multilang style="width: 60%;">
                        {{datas.SecurityInfo}}
                    </span>
                </div>
                <!--Insurance-->
                <div class="infoline">
                    <span multilang class="cc2">Versicherungsinformationen</span>
                    <span multilang style="width: 60%;">
                        {{datas.Insurance}}
                    </span>
                </div>
                <!--ChildSeat-->
                <div class="infoline">
                    <span multilang class="cc2">Kindersitze</span>
                    <span multilang style="width: 60%;">
                        {{datas.ChildSeat}}
                    </span>
                </div>
                <!--DirectionsShort-->
                <span multilang class="cc1">Anfahrt</span>
                <span multilang style="font-weight: 500;">
                    {{datas.DirectionsShort}}
                </span>
                <!--MinimumarkingDays-->
                <span multilang class="cc1">Parkplatz-Nutzungsdauer</span>
                <div class="infoline">
                    <span multilang class="cc2">min. Parkdauer</span>
                    <span multilang style="width: 60%;">
                        {{datas.MinimumParkingDays}}
                    </span>
                </div>
                <div class="infoline">
                    <span multilang class="cc2">max. Parkdauer</span>
                    <span multilang style="width: 60%;">
                        {{datas.MaximumParkingDays}}
                    </span>
                </div>
            </div>
        </div>
    </div>
</div>